import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import L from "leaflet";
import "leaflet-draw";
import "leaflet-draw/dist/leaflet.draw.css";
import MiniMap from "leaflet-minimap";
import { useEffect, useRef, useState } from "react";
import { json, useParams } from "react-router-dom";
import { Card, CardBody, CardHeader, CardTitle, Col, Form, Row } from "reactstrap";
import logo from "../../assets/images/logo.png";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import {
  AddQuizContentByIdCall,
  DeleteQuizContentByIdCall,
  EditQuizContentByIdCall,
  GetAllQuizByIdCall,
} from "../../redux/api/quizTitle.api";
import "./map.css";
import SlideSelectorModal from "./SlideSelectorModal";

function ShowTile({ history }) {
  const userData = history?.location?.state?.data?.array;

  const { id, lang } = useParams();
  const mapRef = useRef(null); // Ref for storing map instance

  const content = userData?.content;

  const [info, setInfo] = useState([]);
  const [geoJson, setGeoJson] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [question, onChangeQuestion] = useState("");
  const [level, setLevel] = useState("1"); // dropdown
  const [points1, setPoints1] = useState(5); // first points input
  const [answer1, setAnswer1] = useState("");
  const [language, setLanguage] = useState("");
  const [answer2, setAnswer2] = useState("");
  const [answer3, setAnswer3] = useState("");
  const [answer4, setAnswer4] = useState("");
  const [titleIdForEdit, setTitleIdForEdit] = useState("");
  const [rightAnswer, setRightAnswer] = useState("");
  const [showForm, setShowForm] = useState(true); // 👈 default open
  const [footage, setFootage] = useState(""); // 👈 default open
  const [footage_type, setFootageType] = useState(""); // 👈 default open
  const [pins, setPins] = useState(""); // 👈 default open
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSlide, setSelectedSlide] = useState("");

  const [tileURL, setTitleURL] = useState("");
  const pinCountRef = useRef(0); // keeps track of how many pins have been added
  const markersRef = useRef([]);

  useEffect(() => {
    fetchQuestions();
  }, []);
  /////////
  console.log("pippo info", info);

  const fetchQuestions = async () => {
    const result = await GetAllQuizByIdCall(id, lang);
    console.log("pippo result", result);

    setQuestions(result);
    // window.location.reload();
  };

  const handleAddSlideClick = () => {
    setModalOpen(true); // open modal
  };

  const handleSlideSelect = (title, slideUrl) => {
    console.log("pippo slideUrl", slideUrl);

    setTitleURL(slideUrl + "/{z}/{x}/{y}.png"); // set slide URL for Leaflet map
    setModalOpen(false);
  };

  /////////
  /////////
  function generateUniqueId() {
    return "id-" + Math.random().toString(36).substr(2, 16);
  }

  // const fetchSlide = async () => {
  //   const res = await GetSlideByIdCall({
  //     id,
  //     lang,
  //   });
  //   ////here ......
  //   if (mapRef.current) {
  //     mapRef.current.remove();
  //     mapRef.current = null;
  //   }
  //   setGeoJson(res);
  //   setTitleURL(`${res?.Files?.[0]?.url}/{z}/{x}/{y}.png`);
  //   // window.location.reload();
  // };

  // At the top of your component

  useEffect(() => {
    if (!tileURL || mapRef.current) return; // Only once

    const map = L.map("map").setView([-10.505, -0.09], 2);
    mapRef.current = map;

    L.tileLayer(tileURL, {
      attribution: '&copy; <a href="https://microlab.ink">Microlab</a> contributors',
    }).addTo(map);

    const drawnItems = new L.FeatureGroup();
    map.addLayer(drawnItems);

    const drawControl = new L.Control.Draw({ edit: { featureGroup: drawnItems } });
    map.addControl(drawControl);

    // Handler for markers
    map.on("draw:created", (e) => {
      if (e.layerType !== "marker") return;

      const latlng = e.layer.getLatLng();
      const labelIndex = pinCountRef.current;
      const label = getPinLabel(labelIndex);

      // Main marker
      const mainMarker = L.marker(latlng).addTo(drawnItems);

      // Label marker
      const labelMarker = L.marker(latlng, {
        icon: L.divIcon({
          className: "custom-pin-label",
          html: `<div style="
            background-color: #007bff;
            color: white;
            font-weight: bold;
            font-size: 14px;
            border-radius: 4px;
            padding: 2px 6px;
            text-align: center;
            width: 20px;
          ">${label}</div>`,
          iconAnchor: [10, 60],
        }),
        interactive: false,
      }).addTo(drawnItems);

      // Save geoJson
      const geoJsonItem = {
        type: "Feature",
        geometry: { type: "Point", coordinates: [latlng.lng, latlng.lat] },
        properties: { id: generateUniqueId(), label },
      };

      // Update state and ref
      setInfo((prev) => [...prev, geoJsonItem]);
      markersRef.current.push({
        marker: mainMarker,
        labelMarker,
        geoJsonId: geoJsonItem.properties.id,
      });

      pinCountRef.current += 1;

      if (label === "A") setAnswer1("Connected to Pin A");
      else if (label === "B") setAnswer2("Connected to Pin B");
      else if (label === "C") setAnswer3("Connected to Pin C");
      else if (label === "D") setAnswer4("Connected to Pin D");
    });
  }, [tileURL]);

  const deletePin = (geoJsonId) => {
    const markerObj = markersRef.current.find((m) => m.geoJsonId === geoJsonId);
    if (!markerObj) return;

    // Remove markers from map
    markerObj.marker.remove();
    markerObj.labelMarker.remove();

    // Remove from refs
    markersRef.current = markersRef.current.filter((m) => m.geoJsonId !== geoJsonId);

    // Remove from state
    const deletedLabel = info.find((item) => item.properties.id === geoJsonId)?.properties.label;
    setInfo((prev) => prev.filter((item) => item.properties.id !== geoJsonId));

    // Clear corresponding answer
    if (deletedLabel === "A") setAnswer1("");
    else if (deletedLabel === "B") setAnswer2("");
    else if (deletedLabel === "C") setAnswer3("");
    else if (deletedLabel === "D") setAnswer4("");

    // Optional: re-label remaining pins
    markersRef.current.forEach((m, i) => {
      const newLabel = getPinLabel(i);
      m.labelMarker.setIcon(
        L.divIcon({
          className: "custom-pin-label",
          html: `<div style="
            background-color: #007bff;
            color: white;
            font-weight: bold;
            font-size: 14px;
            border-radius: 4px;
            padding: 2px 6px;
            text-align: center;
            width: 20px;
          ">${newLabel}</div>`,
          iconAnchor: [10, 60],
        })
      );

      // Update geoJson state
      setInfo((prev) =>
        prev.map((item) =>
          item.properties.id === m.geoJsonId
            ? { ...item, properties: { ...item.properties, label: newLabel } }
            : item
        )
      );
    });

    // Update pin counter
    pinCountRef.current = markersRef.current.length;
  };

  const getPinLabel = (index: number) => {
    const labels = ["A", "B", "C", "D"];
    return labels[index] || String.fromCharCode(65 + index);
  };

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
    // setLanguage(event.target.value);
    // dispatch(setLang(event.target.value));
  };
  const newQuestion = () => {
    setAnswer1("");
    setAnswer2("");
    setAnswer3("");
    setAnswer4("");
    setRightAnswer("");
    setTitleIdForEdit("");
    onChangeQuestion("");
    setTitleURL("");
    setPins("");
    setFootageType("");
    setInfo([]);
  };

  const saveQuestion = async () => {
    if (!titleIdForEdit) {
      const body = {
        title_id: id,
        lang: lang,
        title: "no title",
        content: question,
        answer_a: answer1,
        answer_b: answer2,
        answer_c: answer3,
        answer_d: answer4,
        right_answer: rightAnswer,
        point: points1,
        level: level,
        footage: tileURL ?? "",
        footage_type: tileURL ? "slide" : "",
        pins: JSON.stringify(info),
      };
      await AddQuizContentByIdCall(body);
    } else {
      const body = {
        quiz_id: titleIdForEdit,
        lang: lang,
        title: "no title",
        content: question,
        answer_a: answer1,
        answer_b: answer2,
        answer_c: answer3,
        answer_d: answer4,
        right_answer: rightAnswer,
        point: points1,
        level: level,
        footage: tileURL ?? "",
        footage_type: tileURL ? "slide" : "",
        pins: JSON.stringify(info),
      };
      await EditQuizContentByIdCall(body);
    }
    fetchQuestions();
    onChangeQuestion("");
    setAnswer1("");
    setAnswer2("");
    setAnswer3("");
    setAnswer4("");
    setRightAnswer("");
    setTitleIdForEdit("");
    setTitleURL("");
    setPins("");
    setFootageType("");
    setInfo([]);
  };

  // Delete question
  const handleDelete = async (item, index) => {
    try {
      console.log("pippo item", item);
      console.log("pippo item", item?.id);

      const response = await DeleteQuizContentByIdCall({ quiz_id: item.id });
      // Remove question locally
      fetchQuestions();
      alert("Question deleted successfully!");
    } catch (error) {
      console.error(error);
      alert("Error deleting question");
    }
  };

  // Edit question
  const handleEdit = async (item, index) => {
    // Show prompt to edit content
    try {
      onChangeQuestion(item?.content);
      setLevel(item?.level);
      setLanguage(item.lang);
      setPoints1(item?.point);
      setAnswer1(item?.answer_a);
      setAnswer2(item?.answer_b);
      setAnswer3(item?.answer_c);
      setAnswer4(item?.answer_d);
      setRightAnswer(item?.right_answer);
      setTitleIdForEdit(item?.id);

      setTitleURL(item?.footage);
      setPins(item?.pins ? JSON.parse(item?.pins) : "");
      setFootageType(item?.footage_type);
      setInfo(item?.pins ? JSON.parse(item?.pins) : "");
    } catch (error) {
      console.error(error);
      alert("Error updating question");
    }
  };
  console.log("pippo xxxx", tileURL);

  const disabled = answer1 && answer2 && answer3 && answer4 && rightAnswer && question;

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="content">
        <Row>
          <Col md="12">
            <Card className="card-user">
              <CardHeader>
                <CardTitle tag="h5">
                  {/* Toggle button */}
                  <MDBox mb={2} display="flex" justifyContent="flex-end">
                    <MDButton
                      variant="gradient"
                      color={showForm ? "error" : "success"}
                      onClick={() => setShowForm(!showForm)}
                    >
                      {showForm ? "Close Form" : "Open Form"}
                    </MDButton>
                  </MDBox>

                  {/* Conditionally render form */}
                  {showForm && (
                    <MDBox pt={4} pb={3} px={3}>
                      <MDBox component="form" role="form">
                        {/* Four answers in 2x2 layout with bottom margin */}
                        <Grid item xs={2}>
                          <MDBox mb={4} display="flex" alignItems="center" gap={2}>
                            {/* Language Dropdown */}
                            <FormControl sx={{ minWidth: "45%" }}>
                              <InputLabel>Language</InputLabel>
                              <Select
                                value={lang}
                                disabled
                                onChange={handleLanguageChange}
                                style={{ height: 50 }}
                              >
                                <MenuItem value="en">English</MenuItem>
                                <MenuItem value="pt">Portugal</MenuItem>
                                <MenuItem value="es">Spanish</MenuItem>
                                <MenuItem value="it">Italian</MenuItem>
                                <MenuItem value="ge">Germany</MenuItem>
                                <MenuItem value="nl">Dutch</MenuItem>
                                <MenuItem value="cn">Chinese</MenuItem>
                                <MenuItem value="ja">Japanese</MenuItem>
                                <MenuItem value="ar">Arabic</MenuItem>
                              </Select>
                            </FormControl>

                            {/* Level Dropdown */}
                            <FormControl sx={{ minWidth: "45%" }}>
                              <InputLabel>Level</InputLabel>
                              <Select
                                value={level}
                                onChange={(e) => setLevel(e.target.value)}
                                style={{ height: 50 }}
                              >
                                <MenuItem value="0">Easy</MenuItem>
                                <MenuItem value="1">Medium</MenuItem>
                                <MenuItem value="2">Hard</MenuItem>
                              </Select>
                            </FormControl>
                          </MDBox>
                        </Grid>

                        <MDBox mb={4}>
                          <MDInput
                            value={points1}
                            onChange={(e) => setPoints1(e.target.value)}
                            type="number"
                            label="Points 1"
                            fullWidth
                          />
                        </MDBox>
                        <MDBox mb={4}>
                          <MDInput
                            onChange={(e) => onChangeQuestion(e.target.value)}
                            multiline
                            rows={10}
                            value={question}
                            type="text"
                            mt={5}
                            label="Description"
                            fullWidth
                          />
                        </MDBox>

                        {/* Four answers in 2x2 */}
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <MDBox mb={2}>
                              <MDInput
                                value={answer1}
                                disabled={answer1 === "Connected to Pin A"}
                                onChange={(e) => setAnswer1(e.target.value)}
                                type="text"
                                label="Answer 1"
                                fullWidth
                              />
                            </MDBox>
                          </Grid>
                          <Grid item xs={6}>
                            <MDBox mb={2}>
                              <MDInput
                                value={answer2}
                                disabled={answer2 === "Connected to Pin B"}
                                onChange={(e) => setAnswer2(e.target.value)}
                                type="text"
                                label="Answer 2"
                                fullWidth
                              />
                            </MDBox>
                          </Grid>
                          <Grid item xs={6}>
                            <MDBox mb={2}>
                              <MDInput
                                value={answer3}
                                onChange={(e) => setAnswer3(e.target.value)}
                                disabled={answer3 === "Connected to Pin C"}
                                type="text"
                                label="Answer 3"
                                fullWidth
                              />
                            </MDBox>
                          </Grid>
                          <Grid item xs={6}>
                            <MDBox mb={2}>
                              <MDInput
                                value={answer4}
                                onChange={(e) => setAnswer4(e.target.value)}
                                disabled={answer4 === "Connected to Pin D"}
                                type="text"
                                label="Answer 4"
                                fullWidth
                              />
                            </MDBox>
                          </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <MDBox mb={2}>
                              <FormControl sx={{ minWidth: "100%" }}>
                                <InputLabel>Right Answer</InputLabel>
                                <Select
                                  value={rightAnswer}
                                  onChange={(e) => setRightAnswer(e.target.value)}
                                  style={{ height: 50 }}
                                >
                                  <MenuItem value="1">Answer 1</MenuItem>
                                  <MenuItem value="2">Answer 2</MenuItem>
                                  <MenuItem value="3">Answer 3</MenuItem>
                                  <MenuItem value="4">Answer 4</MenuItem>
                                </Select>
                              </FormControl>
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <MDBox mb={2}>
                              <MDButton
                                variant={"gradient"}
                                color="success"
                                fullWidth
                                style={{
                                  padding: "12px 0", // taller buttons
                                  width: "30%",
                                  height: 50,
                                }}
                                onClick={() => handleAddSlideClick()}
                              >
                                Add Slide
                              </MDButton>
                            </MDBox>
                          </Grid>
                        </Grid>
                        {/* Map Section */}
                        {tileURL && (
                          <div
                            id="map"
                            style={{
                              height: "500px",
                              width: "100%",
                              marginTop: "20px",
                              borderRadius: "8px",
                              overflow: "hidden",
                              marginBottom: "20px",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                            }}
                          ></div>
                        )}

                        {info.map((item) => (
                          <div key={item.properties.id} style={{ marginBottom: "4px" }}>
                            Pin {item.properties.label}{" "}
                            <button
                              style={{ marginBottom: "4px", padding: 5 }}
                              onClick={() => deletePin(item.properties.id)}
                            >
                              Delete
                            </button>
                          </div>
                        ))}

                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <MDButton
                              variant={"gradient"}
                              color="error"
                              fullWidth
                              style={{
                                backgroundColor: !disabled ? "#B0B0B0" : undefined, // grey if disabled
                                cursor: !disabled ? "not-allowed" : "pointer",
                                padding: "12px 0", // taller buttons
                                height: 50,
                              }}
                              onClick={() => newQuestion()}
                              disabled={!disabled}
                            >
                              New
                            </MDButton>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <MDButton
                              variant={"gradient"}
                              color="info"
                              fullWidth
                              style={{
                                backgroundColor: !titleIdForEdit ? "#B0B0B0" : undefined,
                                padding: "12px 0",
                                height: 50,
                              }}
                              onClick={() => saveQuestion()}
                              disabled={!disabled}
                            >
                              {titleIdForEdit ? "Apply Edition" : "Add"}
                            </MDButton>
                          </Grid>
                        </Grid>
                      </MDBox>
                    </MDBox>
                  )}
                </CardTitle>

                {/* Existing questions list */}
                <CardTitle>
                  {questions &&
                    questions.map((item, index) => (
                      <CardBody
                        key={index}
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          padding: "16px",
                          marginBottom: "16px",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                        }}
                      >
                        <Form>
                          {/* Buttons row */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              marginBottom: "10px",
                            }}
                          >
                            <button
                              type="button"
                              style={{
                                backgroundColor: "#1976d2",
                                color: "white",
                                border: "none",
                                padding: "6px 12px",
                                borderRadius: "4px",
                                marginRight: "8px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                const confirmed = window.confirm(
                                  "Do you want to edit this question?"
                                );
                                if (confirmed) handleEdit(item, index);
                              }}
                            >
                              ✏️ Edit
                            </button>

                            <button
                              type="button"
                              style={{
                                backgroundColor: "#d32f2f",
                                color: "white",
                                border: "none",
                                padding: "6px 12px",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                const confirmed = window.confirm(
                                  "Are you sure you want to delete this question?"
                                );
                                if (confirmed) handleDelete(item, index);
                              }}
                            >
                              🗑️ Delete
                            </button>
                          </div>

                          {/* Question content */}
                          <div
                            style={{
                              marginBottom: 20,
                              padding: "10px",
                              backgroundColor: "#f5f5f5",
                              borderRadius: "6px",
                            }}
                          >
                            {item?.content}
                          </div>
                        </Form>
                      </CardBody>
                    ))}
                </CardTitle>
              </CardHeader>
            </Card>
          </Col>
        </Row>
        <SlideSelectorModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          onSelect={handleSlideSelect}
          type="his" // or pass from parent
        />
      </div>
    </DashboardLayout>
  );
}

export default ShowTile;
